import { pushEvent } from '../../client/data-layer';

export const trackExpandPriceRowClick = (
  productId: number,
  productName?: string,
  storeId?: number,
  storeName?: string
) => {
  pushEvent('priceListPriceRowExpanded', {
    productId,
    productName,
    storeId,
    storeName,
  });
};
